// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqSelector_root__vvXJk"};